export default __webpack_public_path__ + "static/media/my_talent_x_logo.fdd64cf0.svg";